<style lang="scss" scoped>
.row {
	cursor: pointer;
	&__container {
		padding: 20px;
		margin-bottom: 10px;
		border-radius: 5px;
		background: rgba(50, 50, 50, 0.07);
		color: $grey--300;
		&:hover {
			background: rgba(76, 133, 255, 0.2);
		}
	}
	&__flag {
		margin-right: 10px;
	}
	&__top {
		@include flex-center;
		padding-bottom: 10px;
		font-size: 18px;
		font-weight: 500;
	}
	&__part {
		margin-right: 20px;
	}
	&__bottom {
		@include flex-center;
		font-size: 14px;
		strong {
			margin-right: 10px;
		}
	}
	&__tag {
		margin-left: auto;
	}
	&__pending {
		.school_name {
			color: $--primary;
		}
	}
	&__approved {
		.school_name {
			color: $--success;
		}
	}
}
</style>

<template lang="pug">
.row(@click="$router.push({ name: 'schools.show', params: { school: row.id } })")
    .row__container(:class="{ 'row__approved' : schoolLinkedToCompany == 'approved', 'row__pending' : schoolLinkedToCompany == 'pending' }")
        .row__top
            flag.row__flag(:code="row.country_iso_3166_2")
            .row__name.school_name {{ row.name }}
            el-tag.row__tag(v-if="schoolLinkedToCompany == 'approved'", size='medium', type="success") APPROVED
            el-tag.row__tag(v-if="schoolLinkedToCompany == 'pending'", size='medium') PENDING
        .row__bottom
            .row__part
                strong ID:
                span {{ row.id }}
            .row__part
                strong Postcode:
                span {{ row.address_postcode }}
            .row__part
                strong URN:
                span {{ row.urn || 'N/A' }}
            .row__part
                strong DfE:
                span {{ row.la_code || 'N/A' }}/{{ row.establishment_number || 'N/A' }}
            .row__part
                strong POE:
                span {{ row.phase_of_education || 'N/A' }}
            .row__part
                strong Country:
                span {{ row.country_name || 'N/A' }}
</template>

<script>
export default {
	name: "SearchRow",
	props: {
		row: {
			type: Object,
			required: true
		},
		associatedSchools: {
			type: Array,
			required: false,
			default: () => []
		}
	},
	computed: {
		schoolLinkedToCompany() {
			const associatedSchool = this.associatedSchools.find(s => s.id == this.row.id);
			if (!associatedSchool) return false;
			return associatedSchool.approved ? "approved" : "pending";
		}
	}
};
</script>
